import { PermissionType } from '../permission-type.enum';

export class Permission {
  public screen: string;
  public items: PermissionItems[] = [];

  constructor(resource: string, items: PermissionItems[]) {
    this.screen = resource;
    this.items = items;
  }

  // static fromGroup(form: FormGroup): Permission {
  //   const screen = form.get('screen')?.value;
  //   const itemsArray = form.get('items') as FormArray;
  //   const items = itemsArray.controls.map((control) =>
  //     PermissionItems.fromGroup(control as FormGroup)
  //   );
  //   return new Permission(screen, items);
  // }

  // toFormGroup(): FormGroup {
  //   const formGroup = new FormGroup({
  //     screen: new FormControl(this.screen),
  //     items: new FormArray(this.items.map((item) => item.toFormGroup())),
  //   });

  //   return formGroup;
  // }
}

export class PermissionItems {
  item: string;
  permissions: PermissionType[];

  constructor(item: string, permissions: PermissionType[]) {
    this.item = item;
    this.permissions = permissions;
  }

  // static fromGroup(form: FormGroup): PermissionItems {
  //   const item = form.get('item')?.value;
  //   const permissions = Object.keys(PermissionType)
  //     .filter((key) => form.get('permissions')?.get(key)?.value)
  //     .map((key) => PermissionType[key as keyof typeof PermissionType]);
  //   return new PermissionItems(item, permissions);
  // }

  // toFormGroup(): FormGroup {
  //   const permissionControls = Object.keys(PermissionType).reduce(
  //     (acc, key) => {
  //       acc[key] = new FormControl(
  //         this.permissions.includes(
  //           PermissionType[key as keyof typeof PermissionType]
  //         )
  //       );
  //       return acc;
  //     },
  //     {} as { [key: string]: FormControl }
  //   );

  //   return new FormGroup({
  //     item: new FormControl(this.item),
  //     permissions: new FormGroup(permissionControls),
  //   });
  // }
}
export interface PermissionInfo {}
export interface Screen {
  screen: string;
  description: string;
  items: PermissionType[];
}
export class PermissionScreens {
  screens: Screen[] = [];
  constructor(enviroment: any) {
    this.screens = [
      new AdminScreen(),
      new PacketsEventsScreen(),
      new PacketsCommandsScreen(),
      new PacketsCommandsBatchScreen(),
      new PacketsStatusScreen(),
      new PacketsLastPositionsScreen(),
      new PacketsSetupActivationScreen(),
      new HyundaiPositionScreen(),
      new ToolsProcessFlowScreen(),
      new ToolsCommandInfoScreen(),
      new ToolsTranslateScreen(),
      new ToolsMapAuxScreen(),
      new OthersFilesScreen(),
      new InfoScreen(),

      new ToolsUtilsScreen(enviroment),
      new VanTransferScreen(),
    ];
  }
}

export class AdminScreen {
  screen: string = 'ADMIN';
  description: string = 'Admin';
  items: any[] = [];
  constructor() {
    this.items.push({
      id: 1,
      item: 'ADMIN',
      description: 'Admin',
      names: ADMIN,
      values: [],
    });
  }
}
export class PacketsEventsScreen {
  screen: string = 'PACKETS_EVENTS';
  description: string = 'Eventos';
  items: any[] = [];
  constructor() {
    this.items.push({
      id: 2,
      item: 'PACKETS_EVENTS',
      description: 'Eventos',
      names: PACKETS_EVENTS,
      values: { READ: false },
    });
    this.items.push({
      id: 5,
      item: 'PACKETS_EVENTS_ANALYTICS',
      description: 'Análise',
      names: PACKETS_EVENTS_ANALYTICS,
      values: { READ: false },
    });
  }
}
export class PacketsCommandsScreen {
  screen: string = 'PACKETS_COMMANDS';
  description: string = 'Comandos';
  items: any[] = [];
  constructor() {
    this.items.push({
      id: 3,
      item: 'PACKETS_COMMANDS',
      description: 'Comandos',
      names: PACKETS_COMMANDS,
      values: { READ: false, CREATE: false },
    });
    this.items.push({
      id: 3,
      item: 'PACKETS_COMMANDS_DIRECT',
      description: 'Comando direto no gateway',
      names: PACKETS_COMMANDS_DIRECT,
      values: { CREATE: false },
    });
  }
}
export class PacketsCommandsBatchScreen {
  screen: string = 'PACKETS_COMMANDS_BATCH';
  description: string = 'Comandos em lote';
  items: any[] = [];
  constructor() {
    this.items.push({
      id: 44,
      item: 'PACKETS_COMMANDS_BATCH',
      description: 'Comandos em lote',
      names: PACKETS_COMMANDS_BATCH,
      values: { READ: false },
    });
  }
}
export class PacketsStatusScreen {
  screen: string = 'PACKETS_STATUS';
  description: string = 'Status';
  items: any[] = [];
  constructor() {
    this.items.push({
      id: 28,
      item: 'PACKETS_STATUS',
      description: 'Status',
      names: PACKETS_STATUS,
      values: { READ: false },
    });
  }
}
export class PacketsSetupActivationScreen {
  screen: string = 'PACKETS_SETUP_ATIVACAO';
  description: string = 'Setup de ativação';
  items: any[] = [];
  constructor() {
    this.items.push({
      id: 29,
      item: 'PACKETS_SETUP_ATIVACAO',
      description: 'Setup de ativação',
      names: PACKETS_SETUP_ATIVACAO,
      values: { READ: false },
    });
  }
}
export class PacketsLastPositionsScreen {
  screen: string = 'PACKETS_LASTPOSITIONS';
  description: string = 'Última posição';
  items: any[] = [];
  constructor() {
    this.items.push({
      id: 4,
      item: 'PACKETS_LASTPOSITIONS',
      description: 'Última posição',
      names: PACKETS_LASTPOSITION,
      values: { READ: false },
    });
  }
}
export class OthersFilesScreen {
  screen: string = 'OTHERS';
  description: string = 'Arquivos';
  items: any[] = [];
  constructor() {
    this.items.push({
      id: 20,
      item: 'OTHERS_FILES',
      description: 'Arquivos',
      names: OTHERS_FILES,
      values: { READ: false, CREATE: false, DELETE: false },
    });
    this.items.push({
      id: 19,
      item: 'OTHERS_FILES_DOWNLOAD',
      description: 'Arquivos (download)',
      names: OTHERS_FILES_DOWNLOAD,
      values: { READ: false },
    });
    this.items.push({
      id: 21,
      item: 'OTHERS_FILES_OTA',
      description: 'Arquivos (OTA)',
      names: OTHERS_FILES_OTA,
      values: { READ: false, CREATE: false },
    });
    this.items.push({
      id: 22,
      item: 'OTHERS_FILES_SEND',
      description: 'Enviar arquivos pela tela de Arquivos',
      names: OTHERS_FILES_SEND,
      values: { CREATE: false },
    });
    this.items.push({
      id: 32,
      item: 'OTHERS_KEEP_ALIVE_LAST_FILE',
      description: 'Keep alive último arquivo',
      names: OTHERS_KEEP_ALIVE_LAST_FILE,
      values: { READ: false, CREATE: false, DELETE: false },
    });
    this.items.push({
      id: 33,
      item: 'OTHERS_KEEP_ALIVE_DEVICES_DOWNLOAD',
      description: 'Keep alive quem pode baixar a lista',
      names: OTHERS_KEEP_ALIVE_DEVICES_DOWNLOAD,
      values: { READ: false, CREATE: false, DELETE: false },
    });
    this.items.push({
      id: 36,
      item: 'OTHERS_SUPPLIER_CONTROL',
      description: 'Controle de fornecedores',
      names: OTHERS_SUPPLIER_CONTROL,
      values: { READ: false, CREATE: false },
    });
  }
}
export class VanTransferScreen {
  screen: string = 'VAN_TRANSFER';
  description: string = 'Van transfer';
  items: any[] = [];
  constructor() {
    this.items.push({
      id: 30,
      item: 'VAN_TRANSFER_DEVICES',
      description: 'Van transfer - Dispositivo',
      names: VAN_TRANSFER_DEVICES,
      values: { READ: false, CREATE: false, UPDATE: false },
    });
    this.items.push({
      id: 31,
      item: 'VAN_TRANSFER_ROUTES',
      description: 'Van transfer - Rotas',
      names: VAN_TRANSFER_ROUTES,
      values: { READ: false, CREATE: false, UPDATE: false, DELETE: false },
    });
  }
}
export class InfoScreen {
  screen: string = 'INFO';
  description: string = 'Info (home)';
  items: any[] = [];
  constructor() {
    this.items.push({
      id: 23,
      item: 'INFO_RDASHBOARD',
      description: 'R Dashboard',
      names: INFO_RDASHBOARD,
      values: { READ: false },
    });
    this.items.push({
      id: 24,
      item: 'INFO_GATEWAYS',
      description: 'Gateways',
      names: INFO_GATEWAYS,
      values: { READ: false },
    });
    this.items.push({
      id: 25,
      item: 'INFO_INSTALLATION_PHOTOS',
      description: 'Fotos da instalação',
      names: INFO_INSTALLATION_PHOTOS,
      values: { READ: false },
    });
    this.items.push({
      id: 26,
      item: 'INFO_PROCESS_AUTO',
      description: 'Process auto',
      names: INFO_PROCESS_AUTO,
      values: { READ: false },
    });
    this.items.push({
      id: 27,
      item: 'INFO_MEGA',
      description: 'Informações Mega',
      names: INFO_MEGA,
      values: { READ: false },
    });
  }
}
export class ToolsUtilsScreen {
  screen: string = 'TOOLS_UTILS';
  description: string = 'Utilidades';
  items: any[] = [];
  constructor(enviroment: any) {
    this.items.push({
      id: 6,
      item: 'TOOLS_UTILS',
      description: 'Utilidades',
      names: TOOLS_UTILS,
      values: { READ: false, CREATE: false },
    });
    this.items.push({
      id: 7,
      item: 'TOOLS_UTILS_LORA_CACHE',
      description: 'Lora cache',
      names: TOOLS_UTILS_LORA_CACHE,
      values: { READ: false, CREATE: false },
    });
    this.items.push({
      id: 8,
      item: 'TOOLS_UTILS_DUMP',
      description: 'DUMP',
      names: TOOLS_UTILS_DUMP,
      values: { READ: false, CREATE: false },
    });
    this.items.push({
      id: 9,
      item: 'TOOLS_UTILS_TEXT_TO_DUMP',
      description: 'Texto para usar no DUMP TCP',
      names: TOOLS_UTILS_TEXT_TO_DUMP,
      values: { CREATE: false },
    });
    this.items.push({
      id: 10,
      item: 'TOOLS_UTILS_TESTLINK_TABLE_TO_LATEX',
      description: 'Converter tabela testlink para latex',
      names: TOOLS_UTILS_TESTLINK_TABLE_TO_LATEX,
      values: { CREATE: false },
    });
    this.items.push({
      id: 11,
      item: 'TOOLS_UTILS_PEG',
      description: 'PEG',
      names: TOOLS_UTILS_PEG,
      values: { CREATE: false },
    });
    this.items.push({
      id: 12,
      item: 'TOOLS_UTILS_SEND_TO_DEV',
      description: 'Enviar pacotes para o ambiente de DEV',
      names: TOOLS_UTILS_SEND_TO_DEV,
      values: { READ: false, CREATE: false },
    });
    if (!enviroment.production) {
      this.items.push({
        id: 13,
        item: 'TOOLS_UTILS_EVENTS_SIMULATOR',
        description: 'Simulador de eventos (DEV)',
        names: TOOLS_UTILS_EVENTS_SIMULATOR,
        values: { CREATE: false },
      });
    }

    this.items.push({
      id: 14,
      item: 'TOOLS_UTILS_SEARCH_GATEWAY',
      description: 'Busca de conexões no gateway',
      names: TOOLS_SEARCH_GATEWAY,
      values: { READ: false },
    });
    this.items.push({
      id: 15,
      item: 'TOOLS_UTILS_NEARBY_DEVICES',
      description: 'Dispositivos próximos',
      names: TOOLS_NEARBY_DEVICES,
      values: { READ: false },
    });
    this.items.push({
      id: 16,
      item: 'TOOLS_UTILS_MOVIDA_EXPRESS_COMMANDS',
      description: 'Comandos para o movida express',
      names: TOOLS_MOVIDA_EXPRESS_COMMANDS,
      values: { READ: false },
    });
    this.items.push({
      id: 17,
      item: 'TOOLS_UTILS_PARSE_AUX',
      description: 'Parser auxiliar',
      names: TOOLS_PARSE_AUX,
      values: { READ: false },
    });
    this.items.push({
      id: 18,
      item: 'TOOLS_UTILS_BREAK_LINES',
      description: 'Quebra de linha para ;',
      names: TOOLS_UTILS_BREAK_LINES,
      values: { CREATE: false },
    });
    this.items.push({
      id: 41,
      item: 'TOOLS_UTILS_SERIAL_VS_ICCID',
      description: 'Pesquisa lista de Serial vs ICCID na Cache',
      names: TOOLS_SERIAL_VS_ICCID,
      values: { READ: false },
    });
    this.items.push({
      id: 42,
      item: 'TOOLS_UTILS_CONSUMER_MAXTRACK',
      description: 'Consumers Maxtrack',
      names: TOOLS_UTILS_CONSUMER_MAXTRACK,
      values: { READ: false },
    });
    this.items.push({
      id: 43,
      item: 'TOOLS_UTILS_FINDMY_CACHE',
      description: 'FindMy Cache',
      names: TOOLS_UTILS_FINDMY_CACHE,
      values: { CREATE: false },
    });
  }
}

export class ToolsMapAuxScreen {
  screen: string = 'TOOLS_MAPS_AUX';
  description: string = 'Mapas auxiliares';
  items: any[] = [];
  constructor() {
    this.items.push({
      id: 37,
      item: 'TOOLS_MAPS_AUX',
      description: 'Mapa auxiliar',
      names: TOOLS_MAPS_AUX,
      values: { READ: false },
    });
  }
}
export class ToolsTranslateScreen {
  screen: string = 'TOOLS_TRANSLATE';
  description: string = 'Tradutor';
  items: any[] = [];
  constructor() {
    this.items.push({
      id: 35,
      item: 'TOOLS_TRANSLATE',
      description: 'Tradudor de pacotes',
      names: TOOLS_TRANSLATE,
      values: { READ: false, CREATE: false },
    });
  }
}
export class ToolsProcessFlowScreen {
  screen: string = 'TOOLS_PROCESS_FLOW';
  description: string = 'Processo de Homologação';
  items: any[] = [];
  constructor() {
    this.items.push({
      id: 39,
      item: 'TOOLS_PROCESS_FLOW',
      description: 'Processo/Fluxo de homologação',
      names: TOOLS_PROCESS_FLOW,
      values: { READ: false, CREATE: false, UPDATE: false },
    });
  }
}
export class ToolsCommandInfoScreen {
  screen: string = 'TOOLS_COMMANDS_INFO';
  description: string = 'Comandos Info';
  items: any[] = [];
  constructor() {
    this.items.push({
      id: 34,
      item: 'TOOLS_COMMANDS_INFO',
      description: 'Informações dos comandos',
      names: TOOLS_COMMANDS_INFO,
      values: { READ: false, CREATE: false, UPDATE: false },
    });
  }
}
export class HyundaiPositionScreen {
  screen: string = 'PACKETS_HYUNDAI';
  description: string = 'Hyndai Bluelink';
  items: any[] = [];
  constructor() {
    this.items.push({
      id: 40,
      item: 'PACKETS_HYUNDAI',
      description: 'Hyndai Eventos',
      names: HYUNDAI_POSITION,
      values: { READ: false },
    });
  }
}


export enum ADMIN {
  READ = 'Visualizar',
  CREATE = 'Adicionar novo usuário e editar usuários',
  //UPDATE = 'Atualizar usuário',
}
export enum PACKETS_EVENTS {
  READ = 'Visualizar',
}
export enum PACKETS_EVENTS_ANALYTICS {
  READ = 'Visualizar',
}
export enum PACKETS_COMMANDS {
  READ = 'Visualizar',
  CREATE = 'Enviar comandos',
}
export enum PACKETS_COMMANDS_DIRECT {
  CREATE = 'Enviar comando direto no gateway',
}
export enum PACKETS_COMMANDS_BATCH {
  READ = 'Visualizar',
}
export enum PACKETS_LASTPOSITION {
  READ = 'Visualizar',
}
export enum PACKETS_STATUS {
  READ = 'Visualizar',
}
export enum PACKETS_SETUP_ATIVACAO {
  READ = 'Visualizar',
}
export enum TOOLS_UTILS {
  READ = 'Visualizar',
}
export enum TOOLS_UTILS_BREAK_LINES {
  CREATE = 'Visualizar',
}
export enum TOOLS_UTILS_LORA_CACHE {
  READ = 'Visualizar se o serial está na cache lora',
  CREATE = 'Inserir na cache',
}
export enum TOOLS_UTILS_DUMP {
  READ = 'Visualizar se o dump está ativo',
  CREATE = 'Ativar o dump',
}
export enum TOOLS_UTILS_TEXT_TO_DUMP {
  CREATE = 'Texto para dump tcp',
}
export enum TOOLS_UTILS_TESTLINK_TABLE_TO_LATEX {
  CREATE = 'Converter texto do testlink para formato latex',
}
export enum TOOLS_UTILS_PEG {
  CREATE = 'Fluxograma PEG',
}
export enum TOOLS_MONITORING {
  READ = 'Visualizar',
}
export enum TOOLS_PROCESS_FLOW {
  READ = 'Visualizar',
  UPDATE = 'Checkar e Comentar',
  // CREATE = "Criar novo fluxo"
}
export enum TOOLS_TRANSLATE {
  READ = 'Visualizar',
}
export enum TOOLS_MAP_AUX {
  READ = 'Visualizar',
}
export enum TOOLS_REPORT {
  READ = 'Visualizar',
}
export enum TOOLS_COMMANDS_INFO {
  READ = 'Visualizar',
  CREATE = 'Adicionar comandos info',
  UPDATE = 'Atualizar comandos info',
}
export enum TOOLS_UTILS_SEND_TO_DEV {
  CREATE = 'Enviar pacotes para DEV',
}
export enum TOOLS_SERIAL_VS_ICCID {
  READ = 'Pesquisa lista de Serial vs ICCID na Cache',
}
export enum TOOLS_UTILS_CONSUMER_MAXTRACK {
  READ = 'Consumers Maxtrack',
}
export enum TOOLS_UTILS_FINDMY_CACHE{
  CREATE = 'FindMy Cache',
}
export enum TOOLS_UTILS_EVENTS_SIMULATOR {
  CREATE = 'Simular eventos (ambiente de DEV)',
}
export enum TOOLS_SEARCH_GATEWAY {
  READ = 'Visualizar',
}
export enum TOOLS_PARSE_AUX {
  READ = 'Visualizar',
}
export enum TOOLS_NEARBY_DEVICES {
  READ = 'Visualizar',
}
export enum TOOLS_MOVIDA_EXPRESS_COMMANDS {
  READ = 'Visualizar',
}
export enum OTHERS_FILES {
  READ = 'Visualizar',
  CREATE = 'Cadastrar arquivos',
  DELETE = 'Inativar arquivos',
}
export enum OTHERS_FILES_OTA {
  READ = 'Visualizar',
}
export enum OTHERS_FILES_DOWNLOAD {
  READ = 'Download arquivo',
}
export enum OTHERS_FILES_SEND {
  CREATE = 'Enviar arquivo',
}
export enum OTHERS_SUPPLIER_CONTROL {
  READ = 'Visualizar',
  CREATE = 'Criar novo',
  UPDATE = 'Editar',
}
export enum OTHERS_KEEP_ALIVE_LAST_FILE {
  READ = 'Visualizar',
  CREATE = 'Adicionar a lista keep alive',
  DELETE = 'Deletar comando keep alive',
}
export enum OTHERS_KEEP_ALIVE_DEVICES_DOWNLOAD {
  READ = 'Visualizar',
  CREATE = 'Adicionar a lista de quem pode baixar',
  DELETE = 'Remover da lista de quem pode baixar e zerar timer',
}
export enum VAN_TRANSFER_DEVICES {
  READ = 'Visualizar',
  CREATE = 'Cadastrar van',
  UPDATE = 'Editar van',
}
export enum VAN_TRANSFER_ROUTES {
  READ = 'Visualizar',
  CREATE = 'Criar rotas',
  UPDATE = 'Editar rotas',
}
export enum INFO_GATEWAYS {
  READ = 'Visualizar',
}
export enum INFO_RDASHBOARD {
  READ = 'Visualizar',
}
export enum INFO_INSTALLATION_PHOTOS {
  READ = 'Visualizar',
}
export enum INFO_PROCESS_AUTO {
  READ = 'Visualizar',
}
export enum INFO_MEGA {
  READ = 'Visualizar',
}
export enum TOOLS_MAPS_AUX {
  READ = 'Visualizar',
}
export enum HYUNDAI_POSITION {
  READ = 'Visualizar',
}
